export interface Account{
    id: string,
    name: string,
    // Shown instead of the "Request" source for this account's transactions (e.g. "Reactive" for Visa)
    requestSourceLabel?: string | null,
    createdBy: string,
    createdAt: Date,
    updatedBy: string,
    updatedAt: Date
}